import type { IconSvgObject } from './types';

const Square01Icon: IconSvgObject = [
  ["path", { d: "M2 21C7.17347 21 9.82653 7 15 7M3 7H4.5C5.53346 7 6.29252 7.66056 6.63647 8.64833L10.3635 19.3517C10.7075 20.3394 11.4665 21 12.5 21H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22.0002 8.99985H18.0002L21.2003 6.59981C21.7039 6.22212 22.0002 5.62938 22.0002 4.9999C22.0002 3.89538 21.1047 2.99999 20.0001 3C18.8956 3.00001 18 3.89543 18 4.99998", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Square01Icon;
